import { render, staticRenderFns } from "./Apicultura.vue?vue&type=template&id=7df5950a"
import script from "./Apicultura.vue?vue&type=script&lang=js"
export * from "./Apicultura.vue?vue&type=script&lang=js"
import style0 from "./Apicultura.vue?vue&type=style&index=0&id=7df5950a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports